import { jsx as _jsx } from "react/jsx-runtime";
export const InfoPanelSummaryDisclaimer = (param)=>{
    let { summary, keywords } = param;
    const hasSummary = !!summary;
    const hasKeywords = !!keywords.length;
    if (!hasSummary && !hasKeywords) return null;
    return /*#__PURE__*/ _jsx("div", {
        className: "mt-2 text-12 text-grey-10",
        children: hasSummary && hasKeywords ? "Summary and smart tags are AI generated" : hasSummary ? "Summary is AI generated" : "Smart tags are AI generated"
    });
};
InfoPanelSummaryDisclaimer.displayName = "InfoPanelSummaryDisclaimer";
